import { Box, Button, Grid, Stack, Typography } from '@mui/material'
import { ReactNode } from 'react'
import CustomModal from '../../components/@extended/modal'

interface IActionAlertModal {
  showAlert: boolean
  title: string
  alertIcon: JSX.Element
  closeIcon?: JSX.Element
  confirmButtonText?: string
  cancelButtonText?: string
  onAlertConfirm?: () => void
  onAlertClose?: () => void
  isDefaultButtonsVisible?: boolean
  children?: ReactNode
  modalContainerMaxWidth?: string
  focusConfirmButton?: boolean
  switchButtonPositions?: boolean
}

const ActionAlertModal = (props: IActionAlertModal) => {
  const { modalContainerMaxWidth } = props

  const confirmAlertModal = (): void => {
    props.onAlertConfirm?.()
  }

  const closeAlertModal = (): void => {
    props.onAlertClose?.()
  }

  return (
    <CustomModal isOpen={props.showAlert}>
      <Grid
        container
        sx={{
          maxWidth: {
            sm: modalContainerMaxWidth ? modalContainerMaxWidth : '27.375rem',
            md: modalContainerMaxWidth ? modalContainerMaxWidth : '27.375rem',
            lg: modalContainerMaxWidth ? modalContainerMaxWidth : '27.375rem',
          },
          minWidth: { sm: '27.375rem', md: '27.375rem', lg: '27.375rem' },
        }}
      >
        {props.closeIcon && (
          <Grid item xs={12}>
            <Stack justifyContent='end' alignItems='end'>
              <Box
                sx={{
                  height: '.875rem',
                  width: '.875rem',
                  mb: '1.15rem',
                  cursor: 'pointer',
                }}
                onClick={closeAlertModal}
              >
                {props.closeIcon}
              </Box>
            </Stack>
          </Grid>
        )}

        <Grid item xs={12}>
          <Stack justifyContent='center' alignItems='center'>
            <Box
              sx={{
                height: '2.875rem',
                width: '2.875rem',
                mb: '2.15rem',
              }}
            >
              {props.alertIcon}
            </Box>

            <Typography
              sx={{
                fontSize: '1.375rem',
                mb: '0.625rem',
                lineHeight: { xs: '1.3', sm: '0.73' },
              }}
              variant='h4'
              textAlign='center'
              color='common.black'
            >
              {props.title}
            </Typography>

            {props.children}

            {props?.isDefaultButtonsVisible && (
              <Box p={'0.625rem'} width={'100%'}>
                <Grid
                  container
                  spacing={'1.25rem'}
                  direction={props?.switchButtonPositions ? 'row-reverse' : 'row'}
                >
                  <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                    <Button
                      sx={{ width: '100%' }}
                      variant={props?.focusConfirmButton ? 'contained' : 'outlined'}
                      size='large'
                      type='submit'
                      onClick={confirmAlertModal}
                    >
                      {props?.confirmButtonText}
                    </Button>
                  </Grid>
                  <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                    <Button
                      sx={{ width: '100%' }}
                      variant={props?.focusConfirmButton ? 'outlined' : 'contained'}
                      size='large'
                      onClick={closeAlertModal}
                    >
                      {props?.cancelButtonText}
                    </Button>
                  </Grid>
                </Grid>
              </Box>
            )}
          </Stack>
        </Grid>
      </Grid>
    </CustomModal>
  )
}

export default ActionAlertModal
